import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Counterparty } from './counterparty.model';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CounterpartyService {
  private apiUrl = `${environment.applicationApi}/messages/counterparties`;

  constructor(private http: HttpClient) { }

  getCounterparties(): Observable<Counterparty[]> {
    return this.http.get<Counterparty[]>(this.apiUrl);
  }
} 